var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-breadcrumbs',{attrs:{"divider":"／","items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-breadcrumbs-item',{staticClass:"item",attrs:{"exact":props.item.exact,"to":props.item.to,"nuxt":""}},[_vm._v("\n      "+_vm._s(props.item.text)+"\n    ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }